var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsNavAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 259",
    d: "M3.00017 12L6.00017 5.99999L10.0002 11L13.0002 3.99999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 238",
    cx: 6,
    cy: 6,
    r: 1,
    fill: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 239",
    cx: 10,
    cy: 11,
    r: 1,
    fill: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 241",
    cx: 3,
    cy: 12,
    r: 1,
    fill: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 240",
    cx: 13,
    cy: 4,
    r: 1,
    fill: "#0F4AA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNavAnalytics);
export default __webpack_public_path__ + "static/media/settings-nav-analytics.c6d178c61479b4de35aed19b3cc6462b.svg";
export { ForwardRef as ReactComponent };